
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonCheckbox
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';
import AutoFillSelect from '@/components/AutoFillSelect.vue';

export default defineComponent({
  name: "DairyGoatSheepDataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonCheckbox,
    AutoFillSelect
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref({});
    const milkingGears = ref([]);
    const dairies = ref([]);
    const selectedDairy = ref<any>({});

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating production data:', error);
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      milkingGears.value = await getMilkingGears();
      dairies.value = await getDairies();
      dataLoaded.value = true;
    });

    const getMilkingGears = async () => {
      try {
        const response = await axiosInstance.get(`api/core/milking-gears/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getDairies = async () => {
      try {
        const response = await axiosInstance.get(`api/core/dairies/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/dairy-goat-sheep-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/dairy-goat-sheep-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const handleSelected = (option: any, item: any, field: string, update = false) => {
      item[field] = option ? option.id : null;
      if (field === 'dairy_object') {
        selectedDairy.value = option;
      }
      if (update) {
        updateData(companyId, item);
      }
    }

    return {
      translations,
      currentLanguage,
      data,
      milkingGears,
      dairies,
      selectedDairy,
      handleSelected,
      submitForm,
    };
  },
});
